// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__3R9CC","rootSuccess":"CompleteLink_rootSuccess__1dp3j","rootFailure":"CompleteLink_rootFailure__1qFJQ","isDisabled":"CompleteLink_isDisabled__1DsPN"};